import isDoneChecking from "../functions/isDoneChecking";
import isDoneCheckingWithSomeErrors from "../functions/isDoneCheckingWithSomeErrors";
import { endStudentPreChecks, endStudentPreChecksWithError, goToNextPreCheckItem } from "../studentPreChecksSlice";
import { CHECKED_ITEMS, PRE_CHECK_MACHINE_STATES } from '../constants'

export const REQUIRED_CHECKS_WITH_FTUE = [...CHECKED_ITEMS]
export const REQUIRED_CHECKS_WITH_AUDIO_CHECKS_ONLY = [
  PRE_CHECK_MACHINE_STATES.networkSpeedChecks,
  PRE_CHECK_MACHINE_STATES.networkPingChecks,
  PRE_CHECK_MACHINE_STATES.hardwareChecks,
  PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks,
  PRE_CHECK_MACHINE_STATES.studentASRChecks,
]
export const REQUIRED_RETURNING_USER_CHECKS = [
  PRE_CHECK_MACHINE_STATES.networkSpeedChecks,
  PRE_CHECK_MACHINE_STATES.networkPingChecks,
  PRE_CHECK_MACHINE_STATES.hardwareChecks,
]

const NOT_DONE = "NOT_DONE"
const ALL_CHECKS_DONE = "ALL_CHECKS_DONE"
const ALL_CHECKS_DONE_WITH_SOME_ERRORS = "ALL_CHECKS_DONE_WITH_SOME_ERRORS"

export default function handlePreCheckItemFinished(listenerApi) {
  const status = (() => {
    const currentState = listenerApi.getState()

    const requiresAudioChecks = currentState.studentPreChecks.settings.shouldDoAudioChecks
    const requiresFirstTimeIntroduction = currentState.studentPreChecks.settings.shouldGoThroughFTUE

    // ALL checks required
    if (requiresFirstTimeIntroduction) {
      if (isDoneChecking(REQUIRED_CHECKS_WITH_FTUE, currentState)) return ALL_CHECKS_DONE
      if (isDoneCheckingWithSomeErrors(REQUIRED_CHECKS_WITH_FTUE, currentState)) return ALL_CHECKS_DONE_WITH_SOME_ERRORS
    }
    // Requires audio checks but not first time experience checks
    if (!requiresFirstTimeIntroduction && requiresAudioChecks) {
      const REQUIRED_CHECKED_ITEMS = REQUIRED_CHECKS_WITH_AUDIO_CHECKS_ONLY
      if (isDoneChecking(REQUIRED_CHECKED_ITEMS, currentState)) return ALL_CHECKS_DONE
      if (isDoneCheckingWithSomeErrors(REQUIRED_CHECKED_ITEMS, currentState)) return ALL_CHECKS_DONE_WITH_SOME_ERRORS
    }
    // Does NOT require FTUE checks and NOT Audio checks
    if (!requiresFirstTimeIntroduction && ! requiresAudioChecks) {
      const REQUIRED_CHECKED_ITEMS = REQUIRED_RETURNING_USER_CHECKS
      if (isDoneChecking(REQUIRED_CHECKED_ITEMS, currentState)) return ALL_CHECKS_DONE
      if (isDoneCheckingWithSomeErrors(REQUIRED_CHECKED_ITEMS, currentState)) return ALL_CHECKS_DONE_WITH_SOME_ERRORS
    }

    return NOT_DONE
  })();

  // cancel all other instances of listner except this one.
  // we only need one of these to trigger and end the check.
  listenerApi.cancelActiveListeners();

  if (status === ALL_CHECKS_DONE) {
    console.log("All checks are done, ending student pre-checks.")
    listenerApi.dispatch(endStudentPreChecks());
    listenerApi.unsubscribe();
  } else if (status === ALL_CHECKS_DONE_WITH_SOME_ERRORS) {
    console.log("All checks are done, ending student pre-checks with errors.")
    listenerApi.dispatch(endStudentPreChecksWithError());
    listenerApi.unsubscribe();
  }else{
    // continue and go to the next checked item, continue listening until all checks are done.
    listenerApi.dispatch(goToNextPreCheckItem())
  }
}